// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"44e214ec","493":"867cef79","521":"2d2076c1","765":"69d13a37","852":"bbe393ea"}[chunkId] + ".chunk.js";
};